import { render, staticRenderFns } from "./view-assigned-project-member.vue?vue&type=template&id=39e4025b&"
import script from "./view-assigned-project-member.vue?vue&type=script&lang=js&"
export * from "./view-assigned-project-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports